import { render } from "./FeePage.vue?vue&type=template&id=21189b7a&ts=true"
import script from "./FeePage.vue?vue&type=script&lang=ts"
export * from "./FeePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__